class ProductCard extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (!(event.target instanceof Element)) return;

    const interactiveElement = event.target.closest(
      'button, input, label, select, [tabindex="1"], quick-add-component, add-to-wishlist-button'
    );

    if (interactiveElement) return;

    const existingLink = event.target.closest('a');
    const existingHref = existingLink?.getAttribute('href');

    if (existingHref && existingHref !== '#' && existingHref !== '') {
      return;
    }

    const productUrl = event.currentTarget.dataset.productUrl;

    if (!productUrl) {
      console.error('URL produit manquante sur la carte produit.');
      return;
    }

    event.preventDefault();
    window.location.assign(productUrl);
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
